var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 35,
    height: 35,
    fill: "url(#pattern0_14_77)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_14_77",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14_77",
    transform: "scale(0.00166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14_77",
    width: 600,
    height: 600,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYBAMAAABMSIXvAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpccSiIDOhzN1FFvCyBgWT0H2sAHaxAACY4QSl7/+6B4G9BvRTJfRSJCkD3okAAAAJdFJOUwAaG9Lb1NLe3gP+VcgAAAO2SURBVHja7dmxbcJQGIXRZybgSRE1YoIg2qRjgkiRkgUYgUyABCPQU7EABSswFK1d2AUSug463wTW0f1f41IkSZIkSZIkSZIkSQ/W1HQj+5w6gLWKt2x/zuwv3XbaP6yPW7ou1jXdZQDrExasp2A5Q8uyLMuCBQsWLA+8ZcGCBQuWB96yLMuyYDlDWLBgebNgOUNYsGB5s2A5Q8uyLFiwnKFlwYIFC5YH3rIsy7JgOUNYsGB5s2A5Q1iwYHmzYDlDy7IsWJYFCxYsD7xlwYLlDC3LsmA5Q1iwYHmzYDlDWLBgebNgOUPLsixYlgULFiwPvGXBggULlgfesiwLlmXBcoawYHmzYMFyhrBgebNgwXKGlmVZsJyhZcGCBQuWB96yLAuWZcFyhrBgebNgwXKGsGB5s2DBcoaWZVmWBQsWLFgeeMuC5QwtC5ZlwXKGsGB5s2DBcoawYHmzYMFyhpZlWZYFCxYsWB54y4IFCxYsD7xlWZZlwXKGsGDB8mbBcoawYMHyZsFyhpZlWbBgOUPLggULFiwPvGVZlmXBcoawYMHyZsFyhrBgwfJmwXKGlmVZsCwLFixYHnjLggXLGVqWZcFyhrBgwfJmwXKGsGDB8mbBcoaWZVmwLAsWLFgeeMuCBQsWLA+8ZVkWLMuC5QxhwfJmwYLlDGHB8mbBguUMLcuyYP0jrLKK997B2sQbwGpqupF9Ti2SJEmSJEmSJEmS1N8i3rz9OaP+yTr5jvfV/p7ZOt60H+v3mK6D9XZOd4IFCxasF8E6wIIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgwYIFCxYsWLBgPQXrZx9u18Vax+vHKot48/bnNDVekSRJkiRJkiRJkiQ92B3L7sCBzJkP+gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.af927a92c639de09f3b40e4d7ac1c4a1.svg";
export { ForwardRef as ReactComponent };